var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPedido(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 391 612 401",
    enableBackground: "new 0 391 612 401",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M33.4,704.3C33.4,719,45.3,731,60,731h12.5 c0.3-20.3,7.5-38.6,19.7-53H60C45.3,678,33.4,689.9,33.4,704.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M603.5,604.5l-27.2-89.6 c-3.1-10.3-12.2-17.8-23-18.6l-113.2-8.9c-15.3-1.1-28.3,10.8-28.3,26.1V678H220.6c12.2,14.4,19.4,33,19.7,53h183.9 c0.6-45.8,38-83.2,84.1-83.2c44.7,0,81.3,35.2,83.8,79.3c7.5-4.7,12.5-12.8,12.5-22.2V612C604.9,609.5,604.3,606.7,603.5,604.5z  M567.4,610.9H464.5c-6.4,0-11.9-5.3-11.9-11.9v-76.6c0-6.9,5.8-12.2,12.8-11.7l81.6,6.4c4.7,0.3,8.9,3.6,10.3,8.3l21.4,70.2 C581,603.1,575.5,610.9,567.4,610.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M114.9,663.8h171.4c60.5,0,109.6-49.1,109.6-109.6 l0,0c0-60.5-49.1-109.6-109.6-109.6H114.9c-60.5,0-109.6,49.1-109.6,109.6l0,0C5.1,614.7,54.2,663.8,114.9,663.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0071CE",
    d: "M178.5,515.4c-15,13.9-24.7,33.8-24.7,56c0,6.9,0.8,13.3,2.5,19.7l0,0c3.6,13.9,13.3,25,26.4,30.5l0,0 c2.5,1.1,5.3,1.9,8.3,1.9c10.8,0,19.7-8.9,19.7-19.7c0-6.4-3.1-12.2-7.8-15.8C188.2,575.9,172.1,549.8,178.5,515.4L178.5,515.4z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE0E2D",
    d: "M218.1,576.5c1.1,0.8,2.2,1.7,3.3,2.5c5.8,5,9.4,12.2,9.4,20.3c0,6.4-2.2,11.9-5.8,16.6c0,0,0,0-0.3,0.3 c8-9.7,13-22.2,13-35.8c0-15-6.1-28.9-15.8-38.8c-9.4-10-15.8-23.9-15.8-38.8c0-6.1,1.1-12.2,2.8-17.8l0,0 c0,0-13.6,18.6-13.6,45.5c0,1.1,0,2.2,0,3.6C196.8,550.9,205.4,566.2,218.1,576.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00833E",
    d: "M224.2,522.9c-13.6-17.2-15-38.3-15-38.3c-1.9,5.5-2.8,11.7-2.8,17.8c0,15,6.1,28.9,15.8,38.8 c9.4,10,15.8,23.9,15.8,38.8c0,13.6-5,26.1-13,35.8c-0.3,0.3-0.3,0.8,0.3,1.7c1.1,1.1,2.5-0.3,2.5-0.3 c23-16.4,19.7-41.6,19.7-41.6C247.3,545.4,224.2,522.9,224.2,522.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M199.8,485.7c-6.7,11.4-10.5,24.7-10.5,38.8c0,23,10.3,43.6,26.4,57.4c0,0,9.4,6.9,9.4,19.7 c0,16.6-12.2,21.9-20.8,23.6c0,0-0.3,0-0.3-0.3c0-0.3,0.3-0.3,0.3-0.3c8.3-3.1,13.9-11.1,13.9-20.5c0-11.1-8.3-17.2-8.3-17.2 c-28.3-23-26.9-56.6-26.9-56.6c0-16.9,5.8-32.7,15.5-44.9c0,0,0.6-0.8,1.4-0.6C200.7,484.9,199.8,485.7,199.8,485.7z"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M129.9,430.2h51.3c8.3,0,15-6.7,15-15 s-6.7-15-15-15h-51.3c-8.3,0-15,6.7-15,15S121.6,430.2,129.9,430.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M156.3,676c-30.8,0-55.8,25-55.8,55.8 c0,30.8,25,55.8,55.8,55.8s55.8-25,55.8-55.8C212,701,187.1,676,156.3,676z M156.3,759.3c-15.3,0-27.5-12.2-27.5-27.5 c0-15.3,12.2-27.5,27.5-27.5c15.3,0,27.5,12.2,27.5,27.5C183.7,747.1,171.5,759.3,156.3,759.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    d: "M508.3,676c-30.8,0-55.8,25-55.8,55.8 c0,30.8,25,55.8,55.8,55.8c30.8,0,55.8-25,55.8-55.8C564.1,701,539.1,676,508.3,676z M508.3,759.3c-15.3,0-27.5-12.2-27.5-27.5 c0-15.3,12.2-27.5,27.5-27.5c15.3,0,27.5,12.2,27.5,27.5C535.8,747.1,523.6,759.3,508.3,759.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedido);
export default __webpack_public_path__ + "static/media/Pedido.75a2992148da05b290a61704460a22f5.svg";
export { ForwardRef as ReactComponent };